export default __webpack_public_path__ + "static/media/website.f83eb52e.jpg";